// useAutoDismissNotice.js
import { ref, onBeforeUnmount } from 'vue'

export function useAutoDismissNotice(
    duration = 3000,
    defaultMessage = '수정된 정보로 갱신되었습니다.'
) {
    const visible = ref(false)
    const message = ref(defaultMessage)
    let timer = null

    const showNotice = (msg = defaultMessage) => {
        message.value = msg
        visible.value = true

        window.scrollTo(0, 0)

        if (timer) clearTimeout(timer)

        timer = setTimeout(() => {
            visible.value = false
            timer = null
        }, duration)
    }

    const hideNotice = () => {
        if (timer) clearTimeout(timer)
        visible.value = false
    }

    onBeforeUnmount(() => {
        if (timer) clearTimeout(timer)
    })

    return {
        noticeVisible: visible,
        noticeMessage: message,
        showNotice,
        hideNotice
    }
}
